import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ResponsiveMedia from '../../../components/common/ResponsiveMedia';
import api from '../../../services/api';

const estimateReadTime = (content) => {
  const words = (content || '').trim().split(/\s+/).filter(Boolean).length;
  return `${Math.max(1, Math.round(words / 200))} min read`;
};

export default function InsightsPreview() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.getPublicArticles({ limit: '3' })
      .then(res => setArticles(res.articles || []))
      .catch(err => console.error('Error loading insights preview:', err));
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="py-60 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-24 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-5xl md:text-7xl font-serif font-bold text-white mb-8">Thinking for the next move.</h2>
          </div>
          <Link to="/insights" className="text-[11px] font-bold uppercase tracking-widest text-blue-500 hover:text-white transition-colors border-b border-blue-500/30 pb-2">
            Explore All Insights
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {articles.map((article, i) => (
            <motion.div
              key={article.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="aspect-[3/2] rounded-3xl overflow-hidden mb-8">
                <ResponsiveMedia
                  src={article.image_url}
                  alt={article.title}
                  label="INSIGHT IMAGE"
                  aspectRatio="aspect-[3/2]"
                  className="transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="space-y-4">
                <div className="flex justify-between items-center text-[10px] font-bold uppercase tracking-widest text-zinc-500">
                  <span className="text-blue-500">{article.category}</span>
                  <span>{estimateReadTime(article.content)}</span>
                </div>
                <h3 className="text-2xl font-serif font-bold text-white group-hover:text-blue-500 transition-colors leading-tight">
                  {article.title}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <Link to="/insights" className="inline-block text-[10px] font-bold uppercase tracking-widest text-white pt-4 group-hover:translate-x-2 transition-transform">
                  Read Insight →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
